import React, { useMemo } from "react";
import PropTypes from "prop-types";
import {
    Line,
    LineChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

// Pontos do gráfico de Atendimentos (dia da semana ou mês), também usados na exportação
export function buildAttendanceData(proceduresSummary, queryType) {
    const categories = queryType === "week"
        ? ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
        : ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

    const points = queryType === "week" ? 7 : 12;
    const scheduled = Array(points).fill(0);
    const done = Array(points).fill(0);

    (proceduresSummary || []).forEach((summaryItem) => {
        const timeUnitIndex = (summaryItem?.timeUnit || 0) - 1;
        if (timeUnitIndex < 0 || timeUnitIndex >= points) {
            return;
        }

        (summaryItem?.count || []).forEach((countItem) => {
            const amount = Number(countItem?.count || 0);
            scheduled[timeUnitIndex] += amount;
            if (countItem?.status === "done") {
                done[timeUnitIndex] += amount;
            }
        });
    });

    return categories.map((label, index) => ({
        label,
        Agendados: scheduled[index],
        Realizados: done[index]
    }));
}

const ProceduresSummary = props => {

    const {
        className,
        innerRef,
        //
        proceduresSummary,
        queryType,
        ...attributes
    } = props;

    const chartData = useMemo(() => buildAttendanceData(proceduresSummary, queryType), [proceduresSummary, queryType]);

    return (
        <div id="activity" >
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f1f1f1" />
                    <XAxis dataKey="label" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Legend />
                    <Line type="monotone" dataKey="Agendados" stroke="#C86B2A" strokeWidth={2} dot={false} />
                    <Line type="monotone" dataKey="Realizados" stroke="#374B45" strokeWidth={2} dot={false} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}

ProceduresSummary.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    //
    innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    proceduresSummary: PropTypes.array,
    queryType: PropTypes.string
};

ProceduresSummary.defaultProps = {
    proceduresSummary: [],
    queryType: "week"
};

export default ProceduresSummary;